import React from 'react';

interface DashboardCardProps {
    title: string;
    iconClass: string;
    value: number | string;
    bgColor: string;
    onClick?: () => void;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ title, iconClass, value, bgColor, onClick }) => {
    return (
        <div className="col-xl col-lg-4 col-md-6 col-12">
            <div 
                className={`card mb-4 ${bgColor} border-0 ${onClick ? 'cursor-pointer' : ''}`}
                onClick={onClick}
                style={onClick ? { cursor: 'pointer' } : undefined}
            >
                <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between mb-3 lh-1">
                        <div>
                            <span className="fs-6 text-uppercase fw-semi-bold">{title}</span>
                        </div>
                        <div>
                            <i className={`${iconClass} fs-5 text-uppercase`}></i>
                        </div>
                    </div>
                    <h2 className="fw-bold mb-1">
                        {value}
                    </h2>
                </div>
            </div>
        </div>
    );
};

export default DashboardCard;
